import { styled } from '@mui/material';
import React, { Suspense } from 'react';
import { useFullScreenHandle } from 'react-full-screen';
import { darkGray } from '../../../../theme/color-constants';
import { EXPORT_REF_ID } from '../../../constants';
import {
  FilterSectionsContext,
  useFilterSectionsContext,
  useGlobalTimeSliderContext,
} from '../../../context/contexts';
import { FullHeightFullScreen } from '../../styles';
import { useAvailableFilterSections } from '../filter/hooks';
import { SideBar } from '../sidebar/SideBar';
import { DashboardPageOptionsContext } from './contexts';
import DashboardPage from './DashboardPage';
import { usePageHandle } from './hooks';
import { DashboardConfig } from './types';

const StyledPageWrapper = styled('div')<{ $fullScreenActive: boolean }>`
  height: ${(props) => (props.$fullScreenActive ? '100%' : 'inherit')};
  background-color: ${(props) =>
    props.$fullScreenActive ? darkGray : 'inherit'};
`;

const StyledWrapper = styled('div')`
  width: 100%;
  height: 100%;
`;

interface DashboardBaseProps {
  dashboardConfig: DashboardConfig;
  selectedPageNumber: number;
}

const DashboardBase = (props: DashboardBaseProps) => {
  const fullScreenHandle = useFullScreenHandle();
  const { dashboardConfig, selectedPageNumber } = props;
  const pageHandle = usePageHandle(dashboardConfig, selectedPageNumber);

  const timeSliderHandle = useGlobalTimeSliderContext();
  const [timeSliderState] = timeSliderHandle;

  const providedFilterFields =
    dashboardConfig.dashboardOptions?.allowedFilterFields ?? [];
  const defaultFilterSectionsContext = useFilterSectionsContext();
  const providedFilterSections = useAvailableFilterSections(
    'filter',
    providedFilterFields,
    timeSliderState
  );
  const filterSections =
    providedFilterFields.length > 0
      ? providedFilterSections
      : defaultFilterSectionsContext;
  if (pageHandle.selected) {
    const pageConfig = pageHandle.selected;
    return (
      <FilterSectionsContext.Provider value={filterSections}>
        <DashboardPageOptionsContext.Provider
          value={pageConfig.pageOptions ?? {}}
        >
          <StyledWrapper>
            <Suspense>
              <SideBar
                pageHandle={pageHandle}
                fullScreenHandle={fullScreenHandle}
                backgroundColor="whitesmoke"
              />
            </Suspense>
            <FullHeightFullScreen
              handle={fullScreenHandle}
              $fullScreenActive={fullScreenHandle.active}
            >
              <StyledPageWrapper
                $fullScreenActive={fullScreenHandle.active}
                id={EXPORT_REF_ID}
              >
                <DashboardPage
                  key={pageHandle.selected.pageId}
                  pageConfig={pageConfig}
                />
              </StyledPageWrapper>
            </FullHeightFullScreen>
          </StyledWrapper>
        </DashboardPageOptionsContext.Provider>
      </FilterSectionsContext.Provider>
    );
  } else {
    return <div>Page not found</div>;
  }
};

export default DashboardBase;
